import React from 'react'

class SuccessPage extends React.Component {
    render() {
        return (
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <h1>Your order is confirmed!</h1>

                    <p>Thank you for purchasing a Corona (PCR) test from us.</p>
                    <p>
                        Please note, the test will be performed approximately 48 hours before the return flight to Israel at the hotel where you are staying (if the laboratory does not arrive at the hotel - we will contact you during the next 2 business days).</p>
                     <p>About 24 hours before the test date, you will be sent a message on WhatsApp or by email with the exact test time.</p>

                    <p>The test results will be sent to you by email by the end of the day after the test, ie the day before your flight back to Israel.</p>
                    <p>We wish you an enjoyable vacation!</p>

                </div>
            </div>
        )
    }
}

export {SuccessPage}